import React from 'react';
import { Button } from '@/components/ui/button';
import { KeenIcon } from '@/components/keenicons';
import { FormattedMessage } from 'react-intl';

const AgentReactivateButton = () => (
  <Button className="mt-8 bg-[#00B14F]">
    <KeenIcon icon="plus" className="me-1" />
    <FormattedMessage id="AGENTS.HOME.ACTIVE_AGENT" />
  </Button>
);

export { AgentReactivateButton }; 